// 养修预约模块中的状态管理
const state = {
  time: ''
}

const mutations = {
  'UPDATE_TIME'(state, time) {
    state.time = time
  }
}

export default {
  state,
  mutations,
  namespaced: true
}
